import React, { useState } from 'react'
import { IoSearchSharp } from "react-icons/io5";
import { searchBar } from '../action';
import { useDispatch } from 'react-redux';

function SearchBar() {
    const dispatch = useDispatch()
    const [input, setInput] = useState('')


    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(searchBar(input))
        setInput('')
    }

    const handleChange = (e) => {
        setInput(e.target.value)
    }

    return (
        <form onSubmit={handleSubmit} className="relative flex items-center w-full max-w-md">
            <div className="relative w-full">
                <input
                    type="text"
                    className="w-full py-2 px-4 pr-10 bg-stone-100 border border-stone-300 rounded text-stone-800 placeholder-stone-500 focus:outline-none focus:ring-1 focus:ring-stone-400 focus:border-stone-400 transition-all duration-200 text-sm"
                    placeholder="Buscar productos..."
                    value={input}
                    onChange={handleChange}
                />
                <button 
                    type='submit' 
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-stone-600 hover:text-stone-800 transition-colors duration-200"
                >
                    <IoSearchSharp className="text-lg" />
                </button>
            </div>
        </form>
    )
}

export default SearchBar